// @flow

import React from 'react';
import bemify, { toModifiers } from 'bemify-js';
import { get } from 'lodash';

import ServiceLogo from 'web-ssr/app/common/components/ServiceLogo';
import Text from 'web-ssr/app/common/components/Text';

import './ServiceDropdownItem.scss';

const bem = bemify('service-dropdown-item');

type Props = {
  app: {},
  isSelected: boolean,
};

const ServiceDropdownItem = (props: Props) => {
  const { app, isSelected } = props;

  const images = get(app, ['images'], {});
  const serviceName = get(app, ['name']);

  return (
    <div
      aria-hidden="true"
      className={bem(toModifiers({ selected: isSelected }))}
    >
      <ServiceLogo
        className={bem('__logo')}
        images={images}
        serviceName={serviceName}
      />
      <Text>{serviceName}</Text>
    </div>
  );
};

export default ServiceDropdownItem;
